import React from "react";
import classes from "./whatsapp.module.css";
import dayjs from "dayjs";
import MorningSvg from "../../../assets/morning_sun.svg";
import AfternoonSvg from "../../../assets/afternoon_sun.svg";
import EveningSvg from "../../../assets/evening_moon.svg";
const Step3 = ({name, mobileNo,language, startDate, endDate, morningTimeSelected, afternoonTimeSelected, eveningTimeSelected}) => {
  const fromDate = dayjs(startDate);
  const toDate = dayjs(endDate);

  return (
    <div className={classes.step3}>
      <div className={classes.step3_section1}>
        <div className={classes.step2_section1_header}>Confirm your details</div>
        <div className={classes.step3_details_section}>
          <div>Name</div>
          <div>{name}</div>
        </div>
        <div className={classes.step3_details_section}>
          <div>Phone Number</div>
          <div>{mobileNo}</div>
        </div>
        <div className={classes.step3_details_section}>
          <div>Language</div>
          <div>{language}</div>
        </div>

        <div className={classes.step3_details_section}>
          <div>Prescription Period</div>
          <div>
            {" "}
            {fromDate.format("MMM D")} to {toDate.format("MMM D YYYY")}
          </div>
        </div>

        <div className={classes.medicine_intake_section}>
          <div>Medicine Intake time</div>
          <div>
            {morningTimeSelected?.length && (
              <div className={classes.selectedIntakeDiv}>
                <div>
                  <img src={MorningSvg} alt="Morning Sun" />
                  &nbsp; Morning
                </div>

                <div className={classes.timeDiv}>{morningTimeSelected}am</div>
              </div>
            )}

            {afternoonTimeSelected?.length && (
              <div className={classes.selectedIntakeDiv}>
                <div>
                  <img src={AfternoonSvg} alt="Afternoon Sun" />
                  &nbsp; Afternoon
                </div>

                <div className={classes.timeDiv}>{afternoonTimeSelected}pm</div>
              </div>
            )}

            {eveningTimeSelected?.length && (
              <div className={classes.selectedIntakeDiv}>
                <div>
                  <img src={EveningSvg} alt="Evening Sun" />
                  &nbsp; Evening
                </div>

                <div className={classes.timeDiv}>{eveningTimeSelected}pm</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step3;
